import ngeohash from 'ngeohash'

import { ParkinglotDetail, SharedParkinglotDetail } from '@/api/server/detail/dto/detailDto'

export const getGeoCodeNeighborsWithSelf = (pin: ParkinglotDetail | SharedParkinglotDetail) => {
  const geoCode = ngeohash.encode(pin.basic.latitude, pin.basic.longitude, 6)
  const geoCodeNeighbors = ngeohash.neighbors(geoCode)
  const geoCodeNeighborsWithSelf = [...geoCodeNeighbors, geoCode].join(',')
  return geoCodeNeighborsWithSelf
}
